// src/LoginPage.js
import React, { useState, useEffect } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import styles from "./LoginPage.css";
import styles from "./LoginPage.module.css";
import { useNavigate } from "react-router-dom"; // Import useNavigate
// import Carousel from "react-bootstrap/Carousel"; // Import Carousel from Bootstrap
import { ToastContainer, toast, cssTransition } from "react-toastify";
import {
  authenticateWithPasskey,
  isPasskeySupported,
} from "./utilities/passkeyAuth";


function LoginPage({ onLogin, onAuthSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // State for error messages
  const [successMessage, setSuccessMessage] = useState(""); // State for success messages
  const [showPassword, setShowPassword] = useState(false); //show password
  const [passkeyLoading, setPasskeyLoading] = useState(false);

  const navigate = useNavigate(); // Initialize navigate function

  useEffect(() => {
    document.body.style.paddingTop = "0";
    return () => {
      document.body.style.paddingTop = "";
    };
  }, []);

  const handlePasskeyLogin = async () => {
    if (!username.trim()) {
      toast.error("Please enter your username first");
      return;
    }

    setPasskeyLoading(true);
    try {
      const response = await authenticateWithPasskey(username);
      
      // Store token and user info like password login
      localStorage.setItem("token", response.token);
      localStorage.setItem("username", response.username);
      localStorage.setItem("role", response.role);
      if (response.regionalCodes) {
        localStorage.setItem("regionalCodes", JSON.stringify(response.regionalCodes));
      }

      // Update App-level auth state so Navbar renders
      if (onAuthSuccess) {
        onAuthSuccess(response.token, response.role, response.username);
      }

      toast.success("Login successful via passkey!");

      // Navigate based on user role
      if (response.role === "lab") {
        navigate("/hospital-portal");
      } else if (response.role === "sales_rep") {
     
        navigate("/dashboardPage");
           // navigate("/sales-details");
      } else if (response.role === "sales_viewer") {
        navigate("/sales-details");
      } else if (
        response.role === "admin" ||
        response.role === "regional_sales_head" ||
        response.role === "Super_Admin"
      ) {
        navigate("/dashboardPage");
      }
    } catch (error) {
      let errorMsg = "Passkey authentication failed. Please try again.";
      
      if (error.message) {
        if (error.message.includes("No passkey registered")) {
          errorMsg = "No passkey registered for this user. Please register a passkey first.";
        } else if (error.message.includes("authentication failed")) {
          errorMsg = "Passkey authentication failed. Please try again or use password login.";
        } else if (error.message.includes("User not found")) {
          errorMsg = "User not found. Please check your username.";
        } else {
          errorMsg = error.message;
        }
      }
      
      toast.error(errorMsg);
      setPasskeyLoading(false);
    } finally {
      setPasskeyLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage(""); // Clear previous error message
    try {
      // Attempt to log in
      await onLogin(username, password);
      // setSuccessMessage("Login successful!");
      toast.success("Login successful!");

      const userRole = localStorage.getItem("role");

      // Navigate based on user role
      if (userRole === "lab") {
        navigate("/hospital-portal");
      } else if (userRole === "sales_rep") {
        navigate("/sales-details");
      } else if (userRole === "sales_viewer") {
        navigate("/sales-details");
      } else if (userRole === "admin" || userRole === "regional_sales_head" || userRole === "Super_Admin"  ) {
        navigate("/dashboardPage");
      }
    } catch (error) {
      let errorMsg = "Login failed. Please try again."; // Default error message
      if (error.response && error.response.data.message) {
        errorMsg = error.response.data.message;
      } else if (error.request) {
        errorMsg = "Network error. Please check your connection.";
      }
      toast.error(errorMsg);
      // setErrorMessage(errorMsg);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <ToastContainer position="bottom-right" autoClose={5000} />

        <div className={styles.loginHeader}>
          <img
            src="https://crm-zeniximages.s3.ap-south-1.amazonaws.com/z+logo+(1).png"
            alt="ZeiniX Logo"
            className={styles.brandLogo}
          />
          <h1>Welcome to ZeiniX CRM</h1>
          <p>Securely access sales, hospital and reporting tools in one place.</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.loginForm}>
          {successMessage && (
            <div className={`${styles.feedback} ${styles.success}`}>{successMessage}</div>
          )}
          {errorMessage && (
            <div className={`${styles.feedback} ${styles.error}`}>{errorMessage}</div>
          )}

          <div className={styles.formGroup}>
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className={styles.formControl}
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={styles.formControl}
            />
          </div>

          <div className={styles.metaRow}>
            <label className={styles.showPassword}>
              <input
                type="checkbox"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
              />
              <span>Show password</span>
            </label>
            <button type="button" className={styles.helpLink} onClick={() => navigate("/unauthorized")}>Forgot password?</button>
          </div>

          <button type="submit" className={styles.loginButton}>Login</button>

          {isPasskeySupported() && (
            <button
              type="button"
              className={styles.passkeyButton}
              onClick={handlePasskeyLogin}
              disabled={passkeyLoading || !username.trim()}
            >
              {passkeyLoading ? "Authenticating..." : "Login with Passkey"}
            </button>
          )}

          <div className={styles.loginNote}>
            Not yet enrolled? Contact your administrator for secure access.
          </div>
        </form>

        <button
          type="button"
          className={styles.trfButton}
          onClick={() => window.location.href = "/trf"}
        >
          Submit Test Request Form
        </button>
      </div>
    </div>
  );
}

export default LoginPage;
